import Nullstack from 'nullstack';
export default function IconBuildingFactory2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-factory-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h18"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-12l5 4v-4l5 4h4"
  }), "   ", Nullstack.element("path", {
    d: "M19 21v-8l-1.436 -9.574a0.5 .5 0 0 0 -.495 -.426h-1.145a0.5 .5 0 0 0 -.494 .418l-1.43 8.582"
  }), "   ", Nullstack.element("path", {
    d: "M9 17h1"
  }), "   ", Nullstack.element("path", {
    d: "M14 17h1"
  }), " ");
}